import { html, LitElement, css, unsafeCSS, render } from 'lit';

import './card';

import style from './comments.scss';
import { parseHTML } from '../shared/parse';
import { getUserData } from '../shared/utils';

export class CommentsComponent extends LitElement {

    static get properties() {
        return {
            path: String,
            comments: Array,
            error: String
        }
     }

    constructor() {
        super();
        this.path = '';
        this.comments = [];
        this.error = '';
        this.userData = null;
    }

    static styles = css`
        ${unsafeCSS(style)}        
    `;

    connectedCallback() {
        super.connectedCallback();      
        this.loadUserData();  
        this.fetchData();
    }

    async loadUserData(){
        const user = await getUserData();
        if(user){
            this.userData = user;
            this.requestUpdate();
        }
    }

    async fetchData() {                        
        if(!this.path){
            return;
        }
        let json = await fetch(`./api/comments?path=${this.path.replace(/_/g,'%20')}`);
        let comments = await json.json();
        this.comments = comments;        
    }

    async create(ev){

        this.error = '';
        let comment = this.shadowRoot.querySelector('textarea');

        if(!comment.value){
            this.error = 'Please input a comment';
            return;
        }

        let res = await fetch('./api/comment',{
            method: 'POST',
            headers: {
                'Accept': '*/*',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                comment: comment.value,
                path: this.path
            })
        });
        
        if(res.status !== 200){
            this.error = res.statusText + '. Please try again';
            return;
        }

        comment.value = '';
        await this.fetchData();
    }

    addCommentPart(type){
        let comment = this.shadowRoot.querySelector('textarea');
        let val = prompt(`Please enter the ${type} name:`);
        if(val){
            comment.value += `[${type}=${val}]`;
            let prev = this.shadowRoot.querySelector('.preview');
            let template = parseHTML(comment.value,true);
            render(template,prev);
            comment.focus();
        }
    }
   
    render() {
        return html`            
            <h3 class="title">Comments</h3>     
            <div class="comments">
            ${this.comments.map(c=>{
                let dte = new Date(c.date);
                return html`
                    <div class="comment">
                        ${c.userid ? html`
                        <small>By <span class="flavor" style="display:inline-block;"><discorduser-component user=${c.userid}></discorduser-component></span> on ${dte.toDateString()}</small>`:''}               
                        <p>${parseHTML(c.comment,true)}</p>
                    </div>
                `;
            })}  
            ${this.comments.length === 0 ? html`<p>No comments yet!</p>`:''}     
            </div>
            <h3>Contribute</h3>
            <p>Please keep the following in mind when posting a comment:</p>
            <ul>
                <li>Your comment must be in English or it will be removed.</li>
                <li>You might want to proof-read your comments before posting them.</li>
            </ul>
            ${this.userData ? html`
            <h4>Post your Comment</h4>    
            <div class="button small" @click=${()=>this.addCommentPart('card')}>Add Card</div>  
            <div class="button small" @click=${()=>this.addCommentPart('talent')}>Add Talent</div>        
            <div class="button small" @click=${()=>this.addCommentPart('monster')}>Add Monster</div>        
            <div class="button small" @click=${()=>this.addCommentPart('event')}>Add Event</div>      
            <div class="button small" @click=${()=>this.addCommentPart('status')}>Add Status</div>        
            <div class="button small" @click=${()=>this.addCommentPart('affix')}>Add Affix</div>        
            <textarea rows="10" @keyup=${ev=>{
                let prev = this.shadowRoot.querySelector('.preview');
                let template = parseHTML(ev.target.value,true);
                render(template,prev);
            }}></textarea> 
            <h4>Preview</h4>
            <div class="preview"></div>
            <div style="color:red">${this.error}</div>
            <div class="button" @click=${()=>this.create()}>Submit</div> 
            `:html`
            <p>You need to be logged in to post a comment.</p>
            <p><a class="button" href="./auth/login">Login</a></p>
            `}                 
        `;
    }
}

customElements.define('comments-component', CommentsComponent);